import React from 'react';
import { useDispatch } from 'react-redux';
import { COLORS } from '@gc-npm/utils.enums.colors';

import Glyph from '@gc-npm/components.icon-glyph';
import TextInfo, {
  TEXT_KIND,
  TEXT_COLOR,
  TEXT_SIZE,
  TEXT_ALIGN,
  TEXT_FONT_WEIGHT,
} from '@gc-npm/components.text';
import CustomLink from '@gc-npm/components.custom-link';
import { actions as modalActions } from '@gc-npm/reducers.modals-reducer';

const ModalHeader = ({
  title,
}) => {
  const dispatch = useDispatch();
  const onCloseModal = () => {
    dispatch(
      modalActions.addModal({
        id: '',
      }),
    );
  };

  return (
    <div className="ModalHeader">
      <div className="content">
        {title && (
          <div className="modalTitle">
            <TextInfo
              text={title}
              kind={TEXT_KIND.PARAGRAPH}
              color={TEXT_COLOR.MOVISTAR_BLACK}
              size={TEXT_SIZE.T7}
              align={TEXT_ALIGN.LEFT}
              fontType={TEXT_FONT_WEIGHT.BOLD}
            />
          </div>
        )}
        <div className="close">
          <CustomLink
            taggingInfo={{ debug: true }}
            onClick={onCloseModal}
          >
            <Glyph
              id="cerrar"
              height={14}
              width={14}
              color={TEXT_COLOR.MOVISTAR_BLUE}
            />
          </CustomLink>

        </div>
      </div>

      <hr />
      <style jsx>
        {`
            .ModalHeader{
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                width: 100%;
                .content {
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  padding: 1rem 0;
                  justify-content: ${title ? 'space-between' : 'flex-end'};
                  .modalTitle {
                    flex-grow: 1;
                  }
                } 
            }
            hr {
            width: 100%;
              color: ${COLORS.grey300};
            }
        `}
      </style>
    </div>
  );
};

export default ModalHeader;
